import { useHeader } from 'hooks/useHeaderStore'
import * as Styled from './styled'
import { Outlet } from 'react-router-dom'
import Header from '~components/smarts/Header'
import { useNavigate } from '~hooks'
import { urlHandler } from '~utils/path'

function Layout() {
  const navigate = useNavigate()
  const url = `${process.env.REACT_APP_FRETEBRAS_SITE}/tipo-de-cadastro?q=entrar`
  const handleClickBack = () => navigate(-1)
  const handleClickClose = () => window.open(urlHandler(url), '_self')
  const showHeader = useHeader((state) => state.isVisible)

  return (
    <>
      {showHeader && (
        <Header onClickBack={handleClickBack} onClickClose={handleClickClose} />
      )}
      <Styled.Layout>
        <Styled.Container>
          <Outlet />
        </Styled.Container>
      </Styled.Layout>
    </>
  )
}

export default Layout
